import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import refundpolicy from '../../assets/img/refund-policy.jpg';

const ReturnAndRefund = () => {
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Refund and Return Policy </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name">Refund and Return Policy</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="refund-policy">
                <div className="container">
                    <div className="row">
                        <div className='col-lg-6'>
                            <div>
                                <img src={refundpolicy} alt='' className='img-fluid' />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="refund-policy-main">
                                <div className="terms-services-subtitle">
                                    <h5>Refund and Return</h5>
                                </div>
                                <div className="terms-services-content">
                                    <p>
                                        If any reason, You are not happy and satisfied with your purchased service from our company, we will accept a refund request within 24 hours, we will not accept any refund request after 24 hours. We are not responsible for any kind of refunds after delivered the services.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default ReturnAndRefund;